import { render, staticRenderFns } from "./ManageUnpackedItems.vue?vue&type=template&id=7d84df8d&"
import script from "./ManageUnpackedItems.vue?vue&type=script&lang=js&"
export * from "./ManageUnpackedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports